export const zoom = {
  inserted(el, binding) {
    // 获取配置参数
    const options = binding.value || {};
    const minScale = options.minScale || 1;
    const maxScale = options.maxScale || 2;

    // 初始化状态
    let currentScale = 1;
    let initialDistance = 0;
    let initialScale = 1;

    // 动态设置触摸行为
    const updateTouchAction = () => {
      if (currentScale > 1) {
        el.style.touchAction = "auto"; // 放大后允许水平和垂直滚动
      } else {
        el.style.touchAction = "pan-y"; // 未放大时只允许垂直滚动
      }
    };

    // 更新页面缩放
    const updateScale = (scale) => {
      // 限制缩放范围
      currentScale = Math.max(minScale, Math.min(maxScale, scale));
      el.style.transform = `scale(${currentScale})`;
      el.style.transformOrigin = "center";
      el.style.transition = "transform 0.1s ease"; // 平滑过渡
      // 触发布局更新
      void el.offsetWidth;
      updateTouchAction(); // 更新触摸行为
    };

    // 监听触摸事件
    el.addEventListener("touchstart", (e) => {
      if (e.touches.length === 2) {
        // 计算两指距离
        const x1 = e.touches[0].pageX;
        const y1 = e.touches[0].pageY;
        const x2 = e.touches[1].pageX;
        const y2 = e.touches[1].pageY;
        initialDistance = Math.sqrt(
          Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)
        );
        initialScale = currentScale;
        e.preventDefault(); // 阻止默认行为
      }
    });

    el.addEventListener("touchmove", (e) => {
      if (e.touches.length === 2) {
        // 计算当前两指距离
        const x1 = e.touches[0].pageX;
        const y1 = e.touches[0].pageY;
        const x2 = e.touches[1].pageX;
        const y2 = e.touches[1].pageY;
        const currentDistance = Math.sqrt(
          Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)
        );

        // 计算缩放比例
        const scale = initialScale * (currentDistance / initialDistance);
        updateScale(scale);
        e.preventDefault(); // 阻止默认行为
      } else if (e.touches.length === 1 && !initialDistance) {
        // 单指操作放行（不阻止默认行为）
        return;
      }
    });

    el.addEventListener("touchend", () => {
      initialDistance = 0; // 重置初始距离
    });

    // 初始化触摸行为
    updateTouchAction();
  },
};
